import { render, staticRenderFns } from "./copy-clipboard.vue?vue&type=template&id=d6e85cc0&scoped=true"
import script from "./copy-clipboard.vue?vue&type=script&lang=js"
export * from "./copy-clipboard.vue?vue&type=script&lang=js"
import style0 from "./copy-clipboard.vue?vue&type=style&index=0&id=d6e85cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e85cc0",
  null
  
)

export default component.exports